import React from 'react';
import {
    Show,
    TabbedShowLayout,
    Tab,
    TextField,
    ImageField,
} from 'react-admin';
import { API_BASE_URL } from '../dataProvider';

// Helper to render business hours in a readable format
const BusinessHoursDisplay = ({ record }) => {
    if (!record || !record.businessHours) {
        return (
            <div style={{ 
                padding: '16px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '8px',
                textAlign: 'center',
                color: '#666'
            }}>
                <span style={{ fontStyle: 'italic' }}>No business hours set</span>
            </div>
        );
    }
    
    const days = Object.keys(record.businessHours);
    
    return (
        <div style={{ 
            padding: '16px',
            backgroundColor: '#fafafa',
            borderRadius: '8px',
            border: '1px solid #e0e0e0'
        }}>
    
            <div style={{ display: 'grid', gap: '8px' }}>
                {days.map(day => {
                    const { open, open_time, close_time, week_day } = record.businessHours[day];
                    return (
                        <div 
                            key={week_day} 
                            style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                padding: '8px 12px',
                                backgroundColor: open ? '#fff' : '#f8f8f8',
                                borderRadius: '6px',
                                border: '1px solid #e8e8e8',
                                gap: '12px'
                            }}
                        >
                            <span style={{ 
                                fontWeight: 500,
                                color: '#333',
                                minWidth: '80px',
                                flexShrink: 0
                            }}>
                                {week_day}
                            </span>
                            {open ? (
                                <span style={{ 
                                    color: '#2e7d32',
                                    fontWeight: 500,
                                    backgroundColor: '#e8f5e8',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontSize: '14px'
                                }}>
                                    {open_time} - {close_time}
                                </span>
                            ) : (
                                <span style={{ 
                                    color: '#757575',
                                    fontStyle: 'italic',
                                    backgroundColor: '#f0f0f0',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontSize: '14px'
                                }}>
                                    Closed
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};


const StorePhotoDisplay = ({ record }) => {
    console.log(record);
    
    const hasPhoto = record && record.storePhoto;
    
    const handlePhotoClick = () => {
        if (hasPhoto) {
            window.open(`${API_BASE_URL}/${record.storePhoto}`, '_blank');
        }
    };
    
    return hasPhoto ? (
        <div style={{ marginTop: 16 }}>
            <img 
                src={`${API_BASE_URL}/${record.storePhoto}`} 
                title="Store Photo"
                onClick={handlePhotoClick}
                style={{
                    maxWidth: '500px',
                    maxHeight: '500px',
                    width: 'auto',
                    height: 'auto',
                    cursor: 'pointer',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
                onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.02)';
                    e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                }}
                alt="Store Photo"
            />
        </div>
    ) : (
        <div style={{ color: '#888', fontStyle: 'italic', marginTop: 16 }}>
            Please upload your store front photo and a photo with the Loko window sticker.
        </div>
    );
};

const LocationShow = ({classes, ...props}) => (
    <Show title="Location" {...props}>
        <TabbedShowLayout>
            <Tab label="resources.locations.tabs.info">
                <TextField source="staff_name" label="Staff"/>
                <TextField
                    source="nickName"
                    label="Store Name"
                />
                {/* <EmailField
                    source="email"
                />
                <TextField
                    source="phoneNumber"
                /> */}
                <TextField
                    source="description"
                />
            </Tab>
           
            <Tab label="resources.locations.tabs.address">
                <TextField source="address.address2" label="Unit Number" />
                <TextField source="address.address1" label="Street Address"/>
                <TextField source="address.city" label="City" />
                <TextField source="address.state" label="State"/>
                <TextField source="address.postalCode" label="Postal Code"/>
                <TextField source="address.country" label="Country" />
            </Tab>

             <Tab label="Business Hours">
                <BusinessHoursDisplay />
            </Tab>

             <Tab label="Store Photo">
                <StorePhotoDisplay />
            </Tab>
            {/* <Tab label="resources.accounts.tabs.doc">
                <ArrayField source="files">
                    <SingleFieldList>
                        <FileField source="base64" title="title" />
                    </SingleFieldList>
                </ArrayField>
             </Tab> */}
        </TabbedShowLayout>
    </Show>
);

export default LocationShow;
